/* @flow */
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';
import pickGlobalElementProps from 'utils/pickInputElementProps';

import './styles/Badge.scss';

/**
 * Component used for indicating unreads/unseen state in the form of a pill.
 *
 * ```example
 * <Badge count={5} color="brand" />
 * ```
 */
class Badge extends React.Component {
  static propTypes = {
    /** Number to display in the badge */
    count: React.PropTypes.number,
    /** Background color for the badge */
    color: React.PropTypes.oneOf(['violet', 'brand', 'white', 'lava']),
    /** Size of the badge */
    size: React.PropTypes.oneOf(['xsmall', 'large']),
    shape: React.PropTypes.oneOf(['pill', 'square']),
  };

  static propClasses = {
    color: {
      violet: null,
      brand: 'Badge-brand',
      white: 'Badge-white',
      lava: 'Badge-lava',
    },
    size: {
      small: null,
      xsmall: 'Badge-xSmall',
      large: 'Badge-large',
    },
    shape: {
      square: 'Badge-square',
    },
  };

  static defaultProps = {
    color: 'violet',
    shape: 'pill',
  };

  render() {
    const { className, count, ...others } = this.props;
    const divProps = pickGlobalElementProps(others);

    return (
      <div
        {...divProps}
        className={cx('Badge', getPropClassesFromInstance(this), className)}>
        {count}
      </div>
    );
  }
}

export default Badge;



// WEBPACK FOOTER //
// ./src/components/Badge.jsx